import React, { useContext } from 'react';
import { ApolloContext } from '../../ApolloContextProvider';
import HelpPopup from '../components/helpPopup/HelpPopup';
import RetryButton from './RetryButton';
import {
    DEFAULT_HELP_POPUP_TITLE,
    getUserErrorMessage,
    LANTERN_ERROR_CODES,
} from '../../constants/error';

// Bypasses the apiReducer's screenLevelErrorStatus pipeline (which is cleared by
// every START_API_CALL and would cause flicker). Drives visibility purely from
// ApolloContext, so the overlay stays put until the query actually succeeds.
const AccessibilityErrorOverlay = () => {
    const { accessibilityConfigError, retryConfig } = useContext(ApolloContext);

    if (!accessibilityConfigError) {
        return null;
    }

    return (
        <div className="retry-layout">
            <HelpPopup
                title={DEFAULT_HELP_POPUP_TITLE}
                problem={getUserErrorMessage(LANTERN_ERROR_CODES.NO_CONNECTION)}
                buttons={[<RetryButton key="configRetry" onClick={retryConfig} isPrimary />]}
            />
        </div>
    );
};

export default AccessibilityErrorOverlay;
